import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchQuizAttemptQuizConfigApi, fetchQuzAttemptsApi } from 'api/quiz-attempts-api';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { getQueryString } from 'utils/filters-util';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  quizAttempts: [],
  quizConfig: [],
  loading: true,
  configLoading: true,
  pending: false,
  pagination: {},
};

export const fetchQuizAttemptsListing = createAsyncThunk(
  'quiz-attempts/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchQuzAttemptsApi({}, getQueryString(paramsObj));
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

export const fetchQuizConfig = createAsyncThunk('quiz/config', async () => {
  try {
    const res = await fetchQuizAttemptQuizConfigApi();
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const QuizAttemptsSlice = createSlice({
  name: 'quiz-attempts',
  initialState,
  reducers: {
    setQuizAttemptsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setQuizAttemptsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchQuizAttemptsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchQuizAttemptsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.quizAttempts = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchQuizAttemptsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      })

      .addCase(fetchQuizConfig.pending, (state) => {
        state.configLoading = true;
      })
      .addCase(fetchQuizConfig.fulfilled, (state, action) => {
        state.quizConfig = action?.payload?.quizzes_details || [];
        state.configLoading = false;
      })
      .addCase(fetchQuizConfig.rejected, (state) => {
        state.configLoading = false;
      });
  },
});

export const { setQuizAttemptsActiveColumn, setQuizAttemptsLoading } = QuizAttemptsSlice.actions;
export default QuizAttemptsSlice.reducer;
